<div class="modal-header">
    <h5 class="modal-title" translate>lblServiceResourceAssignments</h5>
    <button type="button" class="close" (click)="dismiss()">
        <span>&times;</span>
    </button>
</div>

<div class="modal-body">
    <!-- Line info -->
    <p class="mb-3">
        <span class="font-weight-bold">{{ lineLabel }}</span>
        <span class="text-muted ml-2 float-right" *ngIf="demandNo || costType || qty != null">
            (D/J: {{ demandNo || '—' }}/{{ jobDetailId || '—' }}<ng-container *ngIf="costType"> | {{ costType
                }}</ng-container><ng-container *ngIf="qty != null"> | Qty: {{ qty }} h</ng-container>)
        </span>
    </p>

    <!-- Header info row -->
    <div class="table-responsive mb-3">
        <table class="tablest1 table-sm">
            <thead>
                <tr>
                    <th *ngIf="isMechanicLineAssignmentInDmsEnabled" translate>lblDmsServiceJobNo</th>
                    <th *ngIf="isMechanicLineAssignmentInDmsEnabled" translate>lblDmsServiceLineNo</th>
                    <th translate>lblResourceNo</th>
                    <th translate>lblResourceName</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td *ngIf="isMechanicLineAssignmentInDmsEnabled">{{ dmsJobLineNo || '—' }}</td>
                    <td *ngIf="isMechanicLineAssignmentInDmsEnabled">{{ dmsLineNo || '—' }}</td>
                    <td>{{ rows.length > 0 ? rows[0].employeeNo : '—' }}</td>
                    <td>{{ rows.length > 0 ? getMechanicName(rows[0].employeeNo) : '—' }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Assignment rows -->
    <div class="table-responsive">
        <table class="tablest1">
            <thead>
                <tr>
                    <th translate>lblResource</th>
                    <th class="text-right" style="width:120px" translate>lblMechanicPortionPercent</th>
                    <th *ngIf="isMechanicLineAssignmentInDmsEnabled" class="text-center" style="width:130px" translate>
                        lblSyncDate</th>
                    <th style="width:60px"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows; let i = index; trackBy: trackByIndex">
                    <td>
                        <div class="d-flex align-items-center">
                            <em *ngIf="isMechanicLineAssignmentInDmsEnabled && row.employeeNo && row.dmsSyncStatus !== 1"
                                class="fas fa-exclamation-triangle fa-lg text-danger mr-2 flex-shrink-0"
                                [ngbTooltip]="'lblNotSynced' | translate" tooltipClass="custom-revert"
                                container="body"></em>
                            <ng-select appendTo="body" [clearable]="false" [searchable]="true"
                                [(ngModel)]="row.employeeNo" [ngModelOptions]="{standalone: true}"
                                placeholder="{{ 'lblSelectMechanic' | translate }}" class="flex-grow-1">
                                <ng-template ng-header-tmp>
                                    <span class="mbold w-100px" translate>lblResourceNo</span>
                                    <span class="mbold" translate>lblResourceName</span>
                                </ng-template>
                                <ng-option *ngFor="let m of availableResources" [value]="m.resourceNo">
                                    <span class="w-100px">{{ m.resourceNo }}</span>
                                    <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                    <span>{{ m.resourceName }}</span>
                                </ng-option>
                            </ng-select>
                        </div>
                        <small class="text-danger" *ngIf="isRowDuplicate(i)"
                            translate>lblDuplicateMechanic</small>
                    </td>
                    <td>
                        <input type="number" class="form-control text-right" [(ngModel)]="row.portionPercent"
                            [ngModelOptions]="{standalone: true}" min="0" max="100" step="1"
                            (change)="onPortionChange(i)" />
                    </td>
                    <td *ngIf="isMechanicLineAssignmentInDmsEnabled" class="text-center">
                        <span *ngIf="row.dmsSyncDate" class="small text-muted">{{ row.dmsSyncDate | date:'shortDate'
                            }}</span>
                        <span *ngIf="!row.dmsSyncDate" class="small text-muted">—</span>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-ico del-icon" (click)="removeRow(i)"
                            [disabled]="isReadOnly || (i === 0 && rows.length > 1)"
                            [ngbTooltip]="(i === 0 && rows.length > 1) ? ('lblPrimaryResourceCannotBeRemoved' | translate) : ('lblRemove' | translate)"
                            tooltipClass="custom-revert" container="body">
                            <em class="far fa-trash-alt fa-lg"></em>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Add row -->
    <div class="mt-2">
        <button class="btn btn-sm btn-outline-primary" (click)="addRow()" [disabled]="!canAddRow">
            <em class="fas fa-plus mr-1"></em><span translate>lblAddResource</span>
        </button>
    </div>

    <!-- Portion total bar -->
    <div class="mt-3">
        <div class="d-flex justify-content-between align-items-center mb-1">
            <span class="font-weight-bold" translate>lblPortionTotal</span>
            <span [ngClass]="isPortionValid ? 'text-success' : 'text-danger'" class="font-weight-bold">
                {{ portionTotal }}%
                <em class="fas" [ngClass]="isPortionValid ? 'fa-check' : 'fa-times'"></em>
            </span>
        </div>
        <div class="progress" style="height: 8px;">
            <div class="progress-bar" [ngClass]="isPortionValid ? 'bg-success' : 'bg-danger'"
                [style.width.%]="portionTotal > 100 ? 100 : portionTotal">
            </div>
        </div>
        <small class="text-muted" translate>lblTotalPortionMustBe100</small>
    </div>

    <!-- Rules -->
    <div class="mt-3 p-2 bg-light rounded">
        <small class="font-weight-bold d-block mb-1" translate>lblRules</small>
        <ul class="mb-0 pl-3">
            <li><small translate>lblRuleTotalMustEqual100</small></li>
            <li><small translate>lblRuleSameMechanicNotTwice</small></li>
            <li *ngIf="costType === 'Personnel'"><small translate>lblRuleMaxFiveResources</small></li>
            <li *ngIf="costType === 'Material' || costType === 'ExtService'"><small
                    translate>lblRuleMaxOneResource</small></li>
            <li *ngIf="costType === 'Personnel'"><small translate>lblRulePrimaryResourceLast</small></li>
        </ul>
    </div>
</div>

<div class="modal-footer d-flex align-items-stretch">
    <button class="btn btn-primary mr-auto" (click)="deleteAll()" [disabled]="isSaving || isReadOnly"
        [ngbTooltip]="'lblDeleteAllResourcesTooltip' | translate" tooltipClass="custom-revert" container="body">
        <em class="fas fa-trash-alt mr-1"></em><span translate>lblDeleteAll</span>
    </button>
    <button class="btn btn-primary" (click)="confirm()" [disabled]="!canConfirm || isSaving || isReadOnly">
        <em class="fas fa-check mr-1"></em><span translate>lblConfirm</span>
    </button>
    <button *ngIf="isMechanicLineAssignmentInDmsEnabled" class="btn btn-primary" (click)="syncAll()"
        [disabled]="!hasUnsyncedRows || isSaving" [ngbTooltip]="'lblSyncAll' | translate" tooltipClass="custom-revert"
        container="body">
        <em class="fas fa-sync-alt mr-1"></em><span translate>lblSyncAll</span>
    </button>
    <button class="btn btn-secondary" (click)="dismiss()">
        <em class="fas fa-times mr-1"></em><span translate>lblCancel</span>
    </button>
</div>